const env = {
    'is_development': (window.X_IS_DEVELOPMENT === "true" || process.env.REACT_APP_IS_DEVELOPMENT === "true" || false),
    'api': window.X_API_URL || process.env.REACT_APP_API_URL,
    'wss': window.X_WSS_URL || process.env.REACT_APP_WSS_URL
};

export default env;